(function() {
    'use strict';

a3_pilot_reports.directive('reportItems',reportItems);

   /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name reportItems
   * @restrict EA
   * @description
   *   Implementation of items
   *
   *   Initialize the telplate items for the pilot report form according to their type
   * @attr {String} type The name of the type to initialize the according Issue template.
   * @example
   *   Usage:
   *   <div report-items type="acuProvision"></div>
   * @ngInject
   */    
function reportItems() {

		function templateUrl(type){
			var template='views/Report/empty.html'; 
			if (type=='acuProvision'){
				template='views/Report/acuProvision.tpl.html';
			}
			// else if(type=='somethingElse'){
			// 	template='views/Report/somethingElse.tpl.html';
			// }
            // ...
			return template; 
		} 
	
		return {
			restrict: 'EA',
			terminal: false,
			templateUrl: function (element, attrs ) { 
				return templateUrl(attrs.type) ;
			},
			scope: false
		}
	}

})();
	